import { VuexModule, Module, mutation, getter, action } from 'vuex-class-component';
import { JobsViewerModeEnum } from "@/types/jobViewerMode";
import moment from 'moment';
import { MONTH_PICKER_FORMAT, DATE_PICKER_FORMAT } from "comunet-jobs-and-technician-repository-shared/constants";
import { Job } from '@/models/jobSummary/job';
import * as JobsAPI from '@/api/jobsApi';

@Module()
export default class JobsStore extends VuexModule {
  @getter public jobsViewerMode: JobsViewerModeEnum = JobsViewerModeEnum.WEEK;
  @getter public jobsViewerSelectedDay: string = moment().format(DATE_PICKER_FORMAT);
  @getter public jobsViewerSelectedMonth: string = moment().format(MONTH_PICKER_FORMAT);
  @getter public loadingJobs: boolean = false;
  @getter public jobs: Job[] = [];
  @getter public jobsLoadError: string = "";

  @mutation public setJobsViewerMode(value: JobsViewerModeEnum): void {
    this.jobsViewerMode = value;
  }

  @mutation public setSelectedDay(value: string): void {
    this.jobsViewerSelectedDay = value;

    // keep the selected month in sync with the selected day
    this.jobsViewerSelectedMonth = moment(this.jobsViewerSelectedDay).format(MONTH_PICKER_FORMAT);
  }

  @mutation public setSelectedMonth(value: string): void {
    this.jobsViewerSelectedMonth = value;

    // keep the selected day in sync with the selected month
    this.jobsViewerSelectedDay = this.jobsViewerSelectedMonth + "-01";
  }

  @mutation public setLoadingJobs(value: boolean): void {
    this.loadingJobs = value;
  }

  @mutation public setJobs(value: Job[]): void {
    this.jobs = value;
  }

  @mutation public setJobsLoadError(value: string): void {
    this.jobsLoadError = value;
  }

  @action public async goToPreviousDate(): Promise<void> {
    if (this.jobsViewerMode === JobsViewerModeEnum.MONTH) {
      let newDate = moment(this.jobsViewerSelectedMonth + "-01").add(-1, "months");
      
      this.setSelectedMonth(newDate.format(MONTH_PICKER_FORMAT));
    }
    else if (this.jobsViewerMode === JobsViewerModeEnum.WEEK) {
      let newDate = moment(this.jobsViewerSelectedDay).add(-1, "weeks");
      
      this.setSelectedDay(newDate.format(DATE_PICKER_FORMAT));
    }
    else if (this.jobsViewerMode === JobsViewerModeEnum.DAY) {
      let newDate = moment(this.jobsViewerSelectedDay).add(-1, "days");
      
      this.setSelectedDay(newDate.format(DATE_PICKER_FORMAT));
    }
  }

  @action public async goToNextDate(): Promise<void> {
    if (this.jobsViewerMode === JobsViewerModeEnum.MONTH) {
      let newDate = moment(this.jobsViewerSelectedMonth + "-01").add(1, "months");
      
      this.setSelectedMonth(newDate.format(MONTH_PICKER_FORMAT));
    }
    else if (this.jobsViewerMode === JobsViewerModeEnum.WEEK) {
      let newDate = moment(this.jobsViewerSelectedDay).add(1, "weeks");
      
      this.setSelectedDay(newDate.format(DATE_PICKER_FORMAT));
    }
    else if (this.jobsViewerMode === JobsViewerModeEnum.DAY) {
      let newDate = moment(this.jobsViewerSelectedDay).add(1, "days");
      
      this.setSelectedDay(newDate.format(DATE_PICKER_FORMAT));
    }
  }

  @action public async loadJobs(): Promise<void> {
    try {
      this.setLoadingJobs(true);

      let selectedYear = moment(this.jobsViewerSelectedDay).year();

      let response = await JobsAPI.getJobs(selectedYear);

      this.setJobs(response);
    }
    catch (ex) {
      this.setJobsLoadError(ex);
    }
    finally {
      this.setLoadingJobs(false);
    }
  }
}